import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import './translations';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './assets/styles/core.scss';
import './assets/styles/generated-tailwind.css';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';
import Clarity from '@microsoft/clarity';

const ignoredSentryErrorPatterns = [
  'DarkReader',
  'runtime.sendMessage',
  'window.ethereum',
  'iabjs://',
  'webxpClient.reset',
  'deploymentConfig.headlessMode',
  'Event `Event` (type=error) captured as promise rejection',
  'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection',
  'Object captured as promise rejection with keys: [object has no keys]',
];

const shouldDropSentryEvent = (event) => {
  const values = event?.exception?.values ?? [];
  const messages = [
    event?.message,
    event?.logentry?.message,
    ...values.map((value) => value?.value),
    ...values.flatMap((value) =>
      value?.stacktrace?.frames?.map((frame) => frame?.filename) ?? [],
    ),
  ].filter(Boolean);

  return messages.some((message) =>
    ignoredSentryErrorPatterns.some((pattern) => message.includes(pattern)),
  );
};

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  beforeSend(event) {
    return shouldDropSentryEvent(event) ? null : event;
  },
});

const getAllowed = () => {
  const ls = localStorage.getItem('cookies');
  return ls ? ls.split(',') : [];
};

if (getAllowed().includes('analysis')) {
  Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID);
  console.log('CLARITY STARTED');
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
